export enum FeatureFlag {
  RSS = 'resto365-rss',
  MASTER_PRODUCT_LIST = 'resto-master-product-list',
  FRANCHISE_HUB = 'resto365-franchisee',
  ORDER_MANAGEMENT = 'order-management',
  RECIPE_MANAGEMENT = 'resto-recipe-mgmt',
  CATERING_TIME_SLOTS = 'resto365-catering-time-slots',
  ADMIN_TOOLS = 'resto365-admin-tools',
  NRO_INSIGHT = 'resto365-nro-insight',
  KITCHEN_MANAGEMENT = 'resto365-kitchen-management',
  EON_REPORTING = 'resto365-eon-reporting',
  RESTAURANT_INSIGHTS = 'resto365-insights',

  /** Network “Global Restaurant” dashboard tab (master list). */
  GLOBAL_RESTAURANT_DASHBOARD = 'global-restaurant-dashboard',

  /** Trading Hours Health tile on the network dashboard. */
  TH_HEALTH_WIDGET = 'th-health-widget',

  /** Digital Training Planner (templates, reporting, restaurant training views). */
  DIGITAL_TRAINING_PLANNER = 'digital-training-planner',

  RECIPE_GUIDE_BUILD_TYPE = 'resto365-recipeguide-build',
  RECIPE_GUIDE_CAFE_HOLA_TYPE = 'resto365-recipeguide-cafehola',

  ASK_GYG = 'askgyg-bhyve',

  /** JSON array of role handles allowed to access Ask GYG (e.g. ["COC", "SCOC"]). */
  ASK_GYG_ROLES = 'askgyg-bhyve-roles'
}
